import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-20 px-6 max-w-2xl mx-auto" data-id="element-61">
      {/* What's Included */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="mb-24" data-id="element-62">
        <h2 className="font-serif text-3xl text-gold-400 mb-10" data-id="element-63">
          What you'll get inside
        </h2>

        <ul className="space-y-6" data-id="element-64">
          {['4 shift models so you can choose what matches your real life (equal blocks, handoff buffer, breastfeeding-protected, early-work protection)', "Handoff scripts for the exact moments that usually explode ('I'm at my limit', 'You don't wake up', 'Stop keeping score')", "Anti-resentment rules you print and follow when you can't be nice", 'A weekly printable planner', 'A 5-minute pre-sleep setup checklist', 'A Plan B protocol for regressions, illness, and travel', 'Bonus: copy-paste texts to start the conversation without triggering defensiveness', "Bonus: ON/OFF card for the fridge/nightstand (so nobody 'forgets')"].map((item, i) => <li key={i} className="flex gap-4 items-start text-lg text-cream-50/90" data-id="element-65">
              <Check className="w-5 h-5 text-gold-400 mt-1 flex-shrink-0" data-id="element-66" />
              <span data-id="element-67">{item}</span>
            </li>)}
        </ul>
      </motion.div>

      {/* Who this is for */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="grid md:grid-cols-2 gap-8" data-id="element-68">
        <div className="bg-navy-800/50 p-8 rounded-xl border border-gold-400/20" data-id="element-69">
          <h3 className="font-serif text-xl text-gold-400 mb-6" data-id="element-70">
            This is for you if:
          </h3>
          <ul className="space-y-4" data-id="element-71">
            {['Nights feel chaotic and unfair', "You dread bedtime because it's where the fights live", "You feel like you're doing all the thinking and all the asking", 'You want something you can implement tonight'].map((item, i) => <li key={i} className="flex gap-3 text-cream-50/90" data-id="element-72">
                <span className="text-gold-400" data-id="element-73">✓</span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="bg-navy-900 p-8 rounded-xl border border-white/5" data-id="element-74">
          <h3 className="font-serif text-xl text-slate-400 mb-6" data-id="element-75">
            This is NOT for you if:
          </h3>
          <ul className="space-y-4" data-id="element-76">
            {["You're looking for baby sleep training tactics (this isn't that)", 'You have zero co-care options and want a partner-based plan', "You want a 'journey' instead of a fix"].map((item, i) => <li key={i} className="flex gap-3 text-slate-400" data-id="element-77">
                <span data-id="element-78">✕</span>
                {item}
              </li>)}
          </ul>
        </div>
      </motion.div>
    </section>;
}